export default __webpack_public_path__ + "media/transfer_window/transfer_completed_valentine-8cec6727.jpg";